'use client';

import { useTerminalModeContext } from '@/providers/terminal-mode-provider';

export function useTerminalMode() {
  const context = useTerminalModeContext();

  // Safe fallback when outside TerminalModeProvider (non-homepage pages)
  if (!context) {
    return {
      isTerminalMode: false,
      setTerminalMode: () => {},
    };
  }

  return context;
}
